// @ts-ignore
import Splide from '@splidejs/splide';

export class Slider {
    slider: HTMLElement;

    constructor(slider) {
        this.slider = slider;
        this.init();
    }

    init() {
        const splide = new Splide(this.slider, {
            type: 'loop',
            perPage: 1,
            gap: 10,
            classes: {
                arrows: 'splide__arrows c-slider__arrows',
                arrow: 'splide__arrow c-slider__arrow',
                prev: 'splide__arrow--prev c-slider__arrow--prev',
                next: 'splide__arrow--next c-slider__arrow--next',
            },
            pagination: true,
            mediaQuery: 'min',
            breakpoints: {
                768: {
                    gap: 20,
                }
            },
        });
        splide.mount();
    }
}

document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll<HTMLElement>('[data-slider]').forEach((slider) => {
        new Slider(slider);
    });
});
